import { PaymentMethod } from '../model/payment-method';
export class PaymentMethodBuilder {
    static buildPaymentMethod(data) {
        let paymentMethod = new PaymentMethod();
        if (!data) {
            return paymentMethod;
        }
        paymentMethod.id = data.paymethod_id;
        paymentMethod.alias = data.alias;
        paymentMethod.lastCardNumbers = data.lastcardnumbers;
        paymentMethod.expirationMonth = data.expiration_month;
        paymentMethod.expirationYear = data.expiration_year;
        paymentMethod.isCorporate = data.type === 'company_card';
        paymentMethod.companyId = data.company_id;
        paymentMethod.costCenterId = data.cost_center;
        paymentMethod.added = data.added;
        paymentMethod.checked = data.checked;
        paymentMethod.type = data.type;
        paymentMethod.merchant_identifier_expiry_date = data.merchant_identifier_expiry_date;
        paymentMethod.in_progress_id_reservation_payment = data.in_progress_id_reservation_payment;
        return paymentMethod;
    }
}
//# sourceMappingURL=payment-method-builder.js.map